/**
 * @module StepperNav
 * @description Componente de navegación visual del stepper wizard.
 * Renderiza los 3 indicadores de paso del flujo de pago:
 * 1. Identificación - Documento de identidad
 * 2. Referencia de pago - Tipo de servicio y referencia
 * 3. Detalle referencia - Resumen y confirmación del pago
 *
 * Las clases CSS "current", "completed", etc. son gestionadas dinámicamente
 * por StepperComponent (componente externo) a través de data-kt-stepper-element="nav".
 * Este componente es puramente presentacional.
 */

import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StepperNav: FC = () => {
  return (
    <div
      className="flex-row-fluid py-lg-5 px-lg-15 rounded-4"
      id="stepper-contenedor"
    >
      <div className="stepper-nav d-flex justify-content-center">
        {/* ── Paso 1: Identificación del usuario ── */}
        <div
          className="stepper-item current"
          data-kt-stepper-element="nav"
        >
          <div className="stepper-line"></div>
          <div className="stepper-icon">
            <i className="stepper-check fas fa-check"></i>
            <FontAwesomeIcon className="stepper-check" icon={"check"} />
            <span className="stepper-number">1</span>
          </div>
          <div className="stepper-label d-xs-none d-sm-none d-dm-block d-lg-block d-none">
            <h3 className="stepper-title">Identificación</h3>
            <div className="stepper-desc">Documento de identidad</div>
          </div>
        </div>

        {/* ── Paso 2: Selección de referencia de pago ── */}
        <div
          className="stepper-item"
          data-kt-stepper-element="nav"
        >
          <div className="stepper-line w-40px"></div>
          <div className="stepper-icon w-40px h-40px">
            <i className="stepper-check fas fa-check"></i>
            <FontAwesomeIcon className="stepper-check" icon={"check"} />
            <span className="stepper-number">2</span>
          </div>
          <div className="stepper-label d-xs-none d-sm-none d-dm-block d-lg-block d-none">
            <h3 className="stepper-title">Referencia de pago</h3>
            <div className="stepper-desc">Tipo de servicio y referencia</div>
          </div>
        </div>

        {/* ── Paso 3: Detalle y confirmación del pago ── */}
        <div
          className="stepper-item"
          data-kt-stepper-element="nav"
        >
          <div className="stepper-line w-40px"></div>
          <div className="stepper-icon w-40px h-40px">
            <i className="stepper-check fas fa-check"></i>
            <FontAwesomeIcon className="stepper-check" icon={"check"} />
            <span className="stepper-number">3</span>
          </div>
          <div className="stepper-label d-xs-none d-sm-none d-dm-block d-lg-block d-none">
            <h3 className="stepper-title">Detalle referencia</h3>
            <div className="stepper-desc">Detalle del pago</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { StepperNav };
